// reducers/profileReducer.js

import { initialGenInfo, initialGenInfoErr } from "Data/userAccount";

export const initialProfileState = {
    userProfileView: null,
    loadingProfile: true,
    profileError: '',

    // 
    userAccData: null,
    accountLoading: true,
    accountError: '',

    // General Info Form State
    activeTab: 'general',
    genInfoForm: initialGenInfo,
    genInfoLoading: false,
    genInfoErrors: initialGenInfoErr,
    //profile  image
    profilePhotoLoading: false,
    profilePhotoError: '',
    profilePhotoFile: null,
    //Cover Photo
    coverPhotoLoading: false,
    coverPhotoError: '',
    coverPhotoFile: null,

    //shared safaries
    userSharedSafariOrg: [],
    userSharedSafariOrgLoading: true,
    userSharedSafariOrgError: '',

    userSharedSafariJoind: [],
    userSharedSafariJoindLoading: true,
    userSharedSafariJoindError: '',

    //follower
    followers: [],
    summaryFollowers: {},
    pageIndexFollowers: 1,

    following: [],
    summaryFollowing: {},
    pageIndexFollowing: 1,

};

export const profileReducer = (state = initialProfileState, action) => {
    switch (action.type) {



        ///
        case 'SET_PROFILE_DATA':
            return {
                ...state,
                userProfileView: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.userProfileView,
            };
        case "SET_PROFILE_DATA_LOADING":
            return {
                ...state,
                loadingProfile: typeof action.payload === "boolean" ? action.payload : state.loadingProfile,
            };
        case "SET_PROFILE_DATA_ERROR":
            return {
                ...state,
                profileError: typeof action.payload === "boolean" ? action.payload : state.profileError,
            };

        //Account Setting
        case 'SET_USER_ACCOUNT_SETTING_DATA':
            return {
                ...state,
                userAccData: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.userAccData,
            };
        case "SET_ACCOUNT_LOADING":
            return {
                ...state,
                accountLoading: typeof action.payload === "boolean" ? action.payload : state.accountLoading,
            };
        case "SET_ACCOUNT_ERROR":
            return {
                ...state,
                accountError: typeof action.payload === "boolean" ? action.payload : state.accountError,
            };

        // General Info Form
        case "SET_ACTIVE_TAB":
            return {
                ...state,
                activeTab: typeof action.payload === "string" ? action.payload : state.activeTab,
            };
        case "SET_GEN_INFO_FORM":
            return {
                ...state,
                genInfoForm: {
                    ...state.genInfoForm,
                    ...action.payload, // partial update
                },
            };
        case "SET_GEN_INFO_ERRORS":
            return {
                ...state,
                genInfoErrors: {
                    ...state.genInfoErrors,
                    ...action.payload, // partial update
                },
            };
        case "SET_GEN_INFO_LOADING":
            return {
                ...state,
                genInfoLoading: typeof action.payload === "boolean" ? action.payload : state.genInfoLoading,
            };
        case "RESET_GEN_INFO_FORM":
            return {
                ...state,
                genInfoForm: initialProfileState.genInfoForm,
            };
        case "RESET_GEN_INFO_ERRORS":
            return {
                ...state,
                genInfoErrors: initialProfileState.genInfoErrors,
            };
        // Profile Image
        case "SET_PROFILE_PHOTO_LOADING":
            return {
                ...state,
                profilePhotoLoading: typeof action.payload === "boolean" ? action.payload : state.profilePhotoLoading,
            };

        case "SET_PROFILE_PHOTO_ERROR":
            return {
                ...state,
                profilePhotoError: typeof action.payload === "string" ? action.payload : '',
            };
        case "SET_PROFILE_PHOTO_FILE":
            return {
                ...state,
                profilePhotoFile: action.payload || null,
            };

        // Cover Image
        case "SET_COVER_PHOTO_LOADING":
            return {
                ...state,
                coverPhotoLoading: typeof action.payload === "boolean" ? action.payload : state.coverPhotoLoading,
            };

        case "SET_COVER_PHOTO_ERROR":
            return {
                ...state,
                coverPhotoError: typeof action.payload === "string" ? action.payload : '',
            };
        case "SET_COVER_PHOTO_FILE":
            return {
                ...state,
                coverPhotoFile: action.payload || null,
            };

        //shared Safari
        case 'SET_USER_SF_ORG_DATA':
            return {
                ...state,
                userSharedSafariOrg: Array.isArray(action.payload)
                    ? action.payload
                    : state.userSharedSafariOrg,
            };
        case 'SET_USER_SF_ORG_DATA_LOADING':
            return {
                ...state,
                userSharedSafariOrgLoading:
                    typeof action.payload === 'boolean'
                        ? action.payload
                        : state.userSharedSafariOrgLoading,
            };
        case 'SET_USER_SF_ORG_DATA_ERROR':
            return {
                ...state,
                userSharedSafariOrgError:
                    typeof action.payload === 'string'
                        ? action.payload
                        : state.userSharedSafariOrgError,
            };

        case 'SET_USER_SF_JOIN_DATA':
            return {
                ...state,
                userSharedSafariJoind: Array.isArray(action.payload)
                    ? action.payload
                    : state.userSharedSafariJoind,
            };
        case 'SET_USER_SF_JOIN_DATA_LOADING':
            return {
                ...state,
                userSharedSafariJoindLoading:
                    typeof action.payload === 'boolean'
                        ? action.payload
                        : state.userSharedSafariJoindLoading,
            };
        case 'SET_USER_SF_JOIN_DATA_ERROR':
            return {
                ...state,
                userSharedSafariJoindError:
                    typeof action.payload === 'string'
                        ? action.payload
                        : state.userSharedSafariJoindError,
            };

        //Following
        case 'SET_PROFILE_FOLLOWING_DATA':
            return {
                ...state,
                following: Array.isArray(action.payload)
                    ? action.payload
                    : state.following,
            };

        case 'APPEND_PROFILE_FOLLOWING_DATA':
            const existingIds1 = new Set(state.following.map(p => p.id));
            const newUniqueParks1 = action.payload.filter(p => !existingIds1.has(p.id));

            return {
                ...state,
                following: [...state.following, ...newUniqueParks1],
            };
        case 'PROFILE_FOLLOWING_SUMMARY':
            return {
                ...state,
                summaryFollowing: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summaryFollowing,
            };

        case 'PROFILE_FOLLOWING_PAGE_INDEX':
            return {
                ...state,
                pageIndexFollowing: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndexFollowing,
            };
        //Followers
        case 'SET_PROFILE_FOLLOWERS_DATA':
            return {
                ...state,
                followers: Array.isArray(action.payload)
                    ? action.payload
                    : state.followers,
            };

        case 'APPEND_PROFILE_FOLLOWERS_DATA':
            const existingIds = new Set(state.followers.map(p => p.user_handle));
            const newUniqueParks = action.payload.filter(p => !existingIds.has(p.user_handle));

            return {
                ...state,
                followers: [...state.followers, ...newUniqueParks],
            };
        case 'PROFILE_FOLLOWERS_SUMMARY':
            return {
                ...state,
                summaryFollowers: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summaryFollowers,
            };

        case 'PROFILE_FOLLOWERS_PAGE_INDEX':
            return {
                ...state,
                pageIndexFollowers: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndexFollowers,
            };
        default:
            return state;
    }
};